import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { graphql } from "react-apollo";
import { lighten } from "polished";
import JobContractsQuery from "../queries/JobContracts";
import { formatPrice } from "../utils/helpers";
import * as colors from "../settings/colors";

const HSmall = styled.span`
  display: block;
  font-size: 13px;
  text-transform: uppercase;
  color: ${colors.TEXT_SECONDARY};
`;

const Total = styled.span`
  color: ${colors.GREEN};
  font-size: 22px;
  margin-top: 3px;

  & a {
    color: ${colors.GREEN};
    text-decoration: none;
  }

  & a:hover {
    color: ${lighten(0.2, colors.GREEN)};
  }
`;

const ContractTotalWrapper = styled.div`
  padding: 20px;
  border: 1px solid ${colors.DIVIDER};
  border-radius: 4px;
  min-width: 180px;
`;

const ContractTotal = ({ className, loading, contracts, contractsPath }) => {
  // TODO: Add loading indicator
  if (loading) return null;

  const contractTotal = contracts
    ? contracts
        .filter(contract => !contract.cancelled)
        .reduce((sum, contract) => sum + contract.amountInCents, 0)
    : 0;

  return (
    <ContractTotalWrapper>
      <HSmall>Contract Total</HSmall>
      <Total>
        <Link to={contractsPath}>{formatPrice(contractTotal)}</Link>
      </Total>
    </ContractTotalWrapper>
  );
};

export default graphql(JobContractsQuery, {
  options: ({ job }) => ({
    variables: { jobId: job.id }
  }),
  props: ({ data: { loading, error, contracts } }) => ({
    loading,
    error,
    contracts
  })
})(ContractTotal);



// WEBPACK FOOTER //
// ./src/components/ContractTotal.js